/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-color-literals */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react/display-name */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import Toast from 'react-native-toast-message';

import * as Layout from '@components/screen/Layout';
import Button from '@components/form/Button';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';
import { isWeb, fullWidth } from '@global/screens';
import { hasNoAccess } from '@global/helpers';
import Image from '@components/global/Image';
import Photo from '@components/global/Photo';
import Alert from '@components/global/Alert';
import ItemDetail from '@components/global/ItemDetail';
import StatusBadge from '@components/global/StatusBadge';
import OrderHeader from '@/screens/transaction/return-order/components/OrderHeader';
import OrderLines from '@/screens/transaction/return-order/components/OrderLines';
import FloatCommentButton from '@components/comment/FloatCommentButton';
import CommentDrawer from '@components/comment/CommentDrawer';

import useApi from '@/hooks/useApi';
import { MsOrder } from '@api/ms-order';
import { MsAccount } from '@api/ms-account';
import { showAlert, setTempData } from '@/store/global';
import { showPopup } from '@/store/modal';

const imageSize = 40;
const trash = {
  width: 13,
  height: 17,
};
const limit = 10;
const img = require('@/assets/img/default/user-image.png');

const ReturnOrderDetailScreen = (props) => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);
  const userRole = auth?.user?.role?.code;
  const [activeTab, setActiveTab] = useState(1);
  const [detailData, setDetailData] = useState({});
  const [detailCustomer, setDetailCustomer] = useState({});
  const [showComments, setShowComments] = useState(
    props.route.params?.openComments === 'true',
  );
  const [products, setProducts] = useState([]);

  const [skip, setSkip] = useState(0);
  const [minimumOrder, setMinimumOrder] = useState(0);
  const [hasAccess, setHasAccess] = useState(false);

  useEffect(() => {
    const access = hasNoAccess([
      'vice_president_finance',
      'budget_controller',
      'finance_head',
      'tax_support',
      'billing_supervisor',
      'general_manager_marketing',
      'marketing_admin',
      'marketing_support',
      detailData?.status !== 'need_approval' ||
      detailData?.current_approval !== userRole
        ? 'distributor_manager'
        : '',
    ]);

    setHasAccess(access);
  }, [detailData?.status]);

  const hasCancelAccess = !hasNoAccess(['superadmin', 'general']);

  const hasRequestConfirmationAccess = !hasNoAccess([
    'superadmin',
    'sales_admin',
    'salesman',
    'sales_supervisor',
    'general',
  ]);

  const tabs = [
    { key: 1, name: 'Details' },
    { key: 2, name: 'Return Order' },
  ];

  const canApproval = () => {
    if (detailData?.status == 'need_approval' && detailData?.current_approval) {
      return Boolean(detailData?.current_approval == userRole);
    } else {
      return false;
    }
  };

  const getSalesOrderDetail = useApi(MsOrder.getReturnOrderDetail);

  const getDetail = async (id) => {
    Promise.all([getSalesOrderDetail.request(id)]).then(
      async ([sales_order]) => {
        let result = {};

        if (
          sales_order?.data?.data &&
          Object.keys(sales_order.data.data).length
        ) {
          result = sales_order.data.data;
          setDetailData(result);
          getProductReturn(result._id);
          if (result?.customer?.id) {
            getCustomer(result.customer.id);
          }
          dispatch(
            setTempData({
              status: result.status,
              current_approval: result.current_approval,
            }),
          );
        }
        // getMinimumOrder(result);
      },
    );
  };

  const getProductReturn = async (id, newSkip = 0, keyword = '') => {
    setSkip(newSkip);
    const isMore = newSkip > 0;
    const filter = { return_quantity: { $gt: 0 } };
    if (keyword) {
      filter.name = { $regex: keyword, $options: 'i' };
    }
    const response = await MsOrder.getProductReturnOrder(id, {
      params: {
        filter: filter,
        skip: newSkip,
        limit: limit,
      },
    });
    if (response?.data?.data?.length) {
      const result = response.data.data;
      if (isMore) {
        const old = JSON.parse(JSON.stringify(products));
        const finalResult = old.concat(result);
        setProducts(finalResult);
      } else {
        setProducts(result);
      }
    } else {
      if (!isMore) {
        setProducts([]);
      }
    }
  };

  const getCustomer = async (id) => {
    const response = await MsAccount.getCustomerId(id);
    if (response?.data?.data?._id) {
      setDetailCustomer(response.data.data);
    }
  };

  const removeReturnOrder = (data) => {
    dispatch(
      showAlert({
        show: true,
        title: 'Delete Return Order',
        description:
          'This Return order will be deleted. Do you want to proceed?',
        onCallback: async () => {
          try {
            if (data && data._id) {
              dispatch(showPopup({ name: 'isLoading', value: true }));
              const removeUser = await MsOrder.deleteReturnOrder(data._id);
              if (removeUser && removeUser.data && removeUser.data.data) {
                dispatch(showPopup({ name: 'isLoading', value: false }));
                Toast.show({
                  text1: 'Successfully deleted Return order',
                  type: 'success',
                });
                props.navigation.navigate('ReturnOrderScreen');
              } else {
                dispatch(showPopup({ name: 'isLoading', value: false }));
                Toast.show({
                  text1: 'Failed to delete Return order',
                  type: 'error',
                });
              }
            }
          } catch (error) {
            dispatch(showPopup({ name: 'isLoading', value: false }));
            Toast.show({ text1: 'A system error occurred', type: 'error' });
          }
        },
      }),
    );
  };

  // change status return  order
  const doChange = async (id, status, force = false) => {
    if (status == 'need_approval' ? detailData?.customer?.id : true) {
      dispatch(showPopup({ name: 'isLoading', value: true }));
      try {
        const payload = {};
        const requestConfirm = await MsOrder.updateReturnOrderStatus(
          id,
          status,
          payload,
        );
        if (requestConfirm && requestConfirm.data && requestConfirm.data.data) {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          let title = '';
          let desc = '';
          if (status == 'need_approval') {
            title = 'Return Order Submitted';
            desc = 'Return order submitted and need confirmation';
          } else if (status == 'cancelled') {
            title = 'Return Order Cancelled';
            desc = 'Return order has been cancelled';
          } else if (status == 'approved') {
            title = 'Return Order Confirmed';
            desc = 'Return order has been confirmed';
          } else if (status == 'draft') {
            title = 'Return Order Submitted';
            desc = 'Return order has been drafted';
          }
          dispatch(
            showAlert({
              show: true,
              title: title,
              description: desc,
              isConfirm: false,
              onCallback: () => {
                if (
                  status == 'need_approval' &&
                  props?.route?.params?.activityId &&
                  props?.route?.params?.taskId
                ) {
                  goToActivity();
                } else {
                  getDetail(props.route.params.id);
                }
              },
            }),
          );
        } else {
          dispatch(showPopup({ name: 'isLoading', value: false }));
          Toast.show({ text1: 'A system error occurred', type: 'error' });
        }
      } catch (error) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        dispatch(
          showAlert({
            show: true,
            title: 'Error',
            description:
              error?.response?.data?.message || 'A system error occurred',
            isConfirm: false,
          }),
        );
      }
    } else {
      try {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({
          text1: 'Please fill in all mandatory data before submit',
          type: 'error',
        });
      } catch (error) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        // Toast.show({ text1: error?.response?.data?.message, type: 'error' });
        dispatch(
          showAlert({
            show: true,
            title: 'Error',
            description:
              error?.response?.data?.message || 'A system error occurred',
            isConfirm: false,
          }),
        );
      }
    }
  };

  // show popup confirmation when we need changing the status
  const changeStatus = async (data, status) => {
    if (data._id) {
      let title = '';
      let desc = '';
      if (status == 'need_approval') {
        title = 'Request Confirmation';
        desc = 'This Return order will be requested. Do you want to proceed?';
      } else if (status == 'cancelled') {
        title = 'Cancel Return Order';
        desc = 'This Return order will be cancelled. Do you want to proceed?';
      } else if (status == 'approved') {
        title = 'Confirm Return Order';
        desc = 'This Return order will be approved. Do you want to proceed?';
      } else if (status == 'draft') {
        title = 'Set to Return Order';
        desc =
          'This Return order will be set to quotation. Do you want to proceed?';
      }
      dispatch(
        showAlert({
          show: true,
          title: title,
          description: desc,
          onCallback: () => {
            doChange(data._id, status);
          },
        }),
      );
    }
  };

  const onDuplicate = async (id) => {
    dispatch(showPopup({ name: 'isLoading', value: true }));
    try {
      const duplicateSalesOrder = await MsOrder.duplicateSalesOrder(id);
      if (duplicateSalesOrder?.data?.data?._id) {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        props.navigation.replace('SalesOrderFormScreen', {
          id: duplicateSalesOrder.data.data._id,
          name: detailData?.customer?.name ? detailData.customer.name : '-',
          titleScreen: detailData.reference_code
            ? detailData.reference_code
            : '-',
        });
      } else {
        dispatch(showPopup({ name: 'isLoading', value: false }));
        Toast.show({ text1: 'Failed to duplicate order', type: 'error' });
      }
    } catch (error) {
      dispatch(showPopup({ name: 'isLoading', value: false }));
      Toast.show({
        text1: error?.response?.data?.message || 'A system error occurred',
        type: 'error',
      });
    }
  };

  const goToActivity = () => {
    props.navigation.navigate('SalesActivityNavigator', {
      screen: 'SalesActivityScreen',
      params: {
        id: props.route.params.activityId,
        direct: 'orders',
      },
    });
  };

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      setMinimumOrder(0);
      setSkip(0);
      setActiveTab(1);
      setDetailData({});
      setDetailCustomer({});
      setProducts([]);
      dispatch(setTempData(null));
      if (props?.route?.params?.id) {
        getDetail(props.route.params.id);
      }
    }
    return () => {
      mounted = false;
    };
  }, [props]);

  // The header's comment entry point lives in RetrurnOrderNavigation.js (it shares the
  // header with the Edit/Cancel/Delete "..." menu, which needs navigator-level state).
  // Bridge the button press back into this screen's drawer state via the route params it sets.
  useEffect(() => {
    if (props.route.params?.showComments) {
      setShowComments(true);
      props.navigation.setParams({ showComments: undefined });
    }
  }, [props.route.params?.showComments]);

  const hasFooter = Boolean(
    !isWeb &&
      ((detailData.status == 'need_approval' && canApproval()) ||
        detailData.status == 'draft'),
  );

  const isDisabledRequestConfirmation = () => {
    return detailData?.subtotal <= minimumOrder;
  };

  const User = (userProps) => {
    return (
      <View
        style={{
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'flex-start',
          ...userProps.style,
        }}
        key={'list-users-' + userProps.index}>
        <Image
          style={{ width: 20, height: 20, marginRight: 8 }}
          width={20}
          height={20}
          isResolveAsset
          source={
            Array.isArray(userProps?.image) && userProps?.image.length > 0
              ? userProps?.image[0]
              : userProps?.image !== ''
              ? userProps?.image
              : img
          }
        />
        <SociollaText
          style={{ fontSize: 12, color: Colors.blue3, alignSelf: 'center' }}>
          {userProps.name}
        </SociollaText>
      </View>
    );
  };

  return (
    <Layout.Container>
      {isWeb && (
        <Layout.Back
          title={
            props.route.params?.name === 'Return Order Approval'
              ? 'Task'
              : 'Return Order'
          }
          onCallback={() => {
            if (
              props?.route?.params?.activityId &&
              props?.route?.params?.taskId
            ) {
              goToActivity();
            } else if (props.route.params?.name === 'Return Order Approval') {
              props.navigation.navigate('TaskNotificationNavigator', {
                screen: 'TaskNotificationScreen',
                params: {
                  task: true,
                },
              });
            } else {
              props.navigation.navigate('ReturnOrderScreen');
            }
          }}
        />
      )}
      <Layout.Wrapper rounded>
        {getSalesOrderDetail.loading ? (
          <Layout.Loader />
        ) : detailData && Object.keys(detailData).length ? (
          <>
            <Layout.ScrollViewRefresher
              isFullHeight
              hasFooter={hasFooter}
              onCallback={() => getDetail(props?.route?.params?.id)}>
              <View style={styles.sectionWrapper}>
                <View
                  style={[
                    styles.rowContainer,
                    {
                      position: 'relative',
                      zIndex: 1,
                      justifyContent: 'space-between',
                    },
                  ]}>
                  <View
                    style={[
                      styles.rowContainer,
                      {
                        width: '100%',
                        maxWidth: isWeb
                          ? `calc(100% - ${imageSize + 45 + 200}px)`
                          : fullWidth - 85,
                      },
                    ]}>
                    <Photo
                      width={imageSize}
                      height={imageSize}
                      image={
                        Array.isArray(detailData?.customer?.image) &&
                        detailData?.customer?.image.length > 0
                          ? detailData?.customer?.image[0]
                          : detailData?.customer?.image !== ''
                          ? detailData?.customer?.image
                          : require('@assets/img/default/user-default.png')
                      }
                    />
                    <SociollaText
                      type="medium"
                      style={{
                        fontSize: 20,
                        maxWidth: isWeb
                          ? `calc(100% - ${imageSize + 45}px)`
                          : fullWidth - 85,
                      }}>
                      {detailData.customer && detailData.customer.name
                        ? detailData.customer.name
                        : '-'}
                    </SociollaText>
                  </View>
                  {isWeb && (
                    <View
                      style={[styles.rowContainer, { position: 'relative' }]}>
                      {['approved', 'need_approval', 'rejected', 'cancelled']
                        .hasDuplicateAccess ? (
                        <Button
                          type="primary"
                          rounded
                          buttonStyle={{ width: 90, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Duplicate
                            </SociollaText>
                          }
                          onPress={() => {
                            onDuplicate(detailData._id);
                          }}
                        />
                      ) : (
                        false
                      )}
                      {
                        // show edit button when status is not need approval, approved and cancelled
                        hasAccess &&
                        !['need_approval', 'approved', 'cancelled'].includes(
                          detailData.status,
                        ) ? (
                          <Button
                            type="primary"
                            rounded
                            buttonStyle={{ width: 80, marginRight: 10 }}
                            title={
                              <SociollaText
                                type="bold"
                                style={{ color: Colors.white }}>
                                Edit
                              </SociollaText>
                            }
                            onPress={() =>
                              props.navigation.replace(
                                'ReturnOrderFormScreen',
                                {
                                  id: detailData._id,
                                  name:
                                    detailData.customer &&
                                    detailData.customer.name
                                      ? detailData.customer.name
                                      : '-',
                                  titleScreen: detailData.reference_code
                                    ? detailData.reference_code
                                    : '-',
                                  source:
                                    detailData.source_order &&
                                    detailData.source_order.id
                                      ? detailData.source_order.id
                                      : '-',

                                  ...(props?.route?.params?.activityId &&
                                  props?.route?.params?.taskId
                                    ? {
                                        // activityId: props.route.params.activityId,
                                        taskId: props.route.params.taskId,
                                      }
                                    : {}),
                                },
                              )
                            }
                          />
                        ) : (
                          false
                        )
                      }
                      {(hasAccess && detailData.status == 'need_approval') ||
                      (detailData.status == 'approved' && hasCancelAccess) ? (
                        // show cancel button when status is need approval
                        <Button
                          type="primary"
                          rounded
                          buttonStyle={{ width: 100, marginRight: 10 }}
                          title={
                            <SociollaText
                              type="bold"
                              style={{ color: Colors.white }}>
                              Cancel
                            </SociollaText>
                          }
                          onPress={() => changeStatus(detailData, 'cancelled')}
                        />
                      ) : (
                        false
                      )}

                      {
                        // show remove button when status is draft
                        hasAccess && detailData.status == 'draft' ? (
                          <Button
                            rounded
                            buttonStyle={{ width: 42 }}
                            title={
                              <Image
                                style={{
                                  width: trash.width,
                                  height: trash.height,
                                }}
                                width={trash.width}
                                height={trash.height}
                                source={require('@assets/img/icons/trash-white.svg')}
                                svg={true}
                              />
                            }
                            onPress={() => removeReturnOrder(detailData)}
                          />
                        ) : (
                          false
                        )
                      }
                      {
                        // show confirm button when status is need approval and user role is superadmin or branch head
                        detailData.status == 'need_approval' &&
                        canApproval() ? (
                          <View
                            style={{
                              position:
                                (hasAccess &&
                                  detailData.status == 'need_approval') ||
                                (detailData.status == 'approved' &&
                                  hasCancelAccess)
                                  ? 'absolute'
                                  : 'relative',
                              right: 0,
                              left: 0,
                              bottom: -50,
                              flexDirection: 'row',
                            }}>
                            <Button
                              rounded
                              buttonStyle={{ width: 100, marginRight: 15 }}
                              title={
                                <SociollaText
                                  type="bold"
                                  style={{
                                    fontSize: 14,
                                    lineHeight: 17,
                                    color: Colors.white,
                                  }}>
                                  Confirm
                                </SociollaText>
                              }
                              onPress={() =>
                                changeStatus(detailData, 'approved')
                              }
                            />
                          </View>
                        ) : (
                          false
                        )
                      }
                      {
                        // show request confirmation button when status is draft
                        hasAccess &&
                        hasRequestConfirmationAccess &&
                        detailData.status == 'draft' ? (
                          <View
                            style={{
                              position: 'absolute',
                              right: 0,
                              left: 0,
                              bottom: -50,
                            }}>
                            <Button
                              rounded
                              buttonStyle={{ width: '100%' }}
                              disabledStyle={{ width: '100%' }}
                              disabled={isDisabledRequestConfirmation()}
                              title={
                                <SociollaText
                                  type="bold"
                                  style={{
                                    fontSize: 12,
                                    lineHeight: 20,
                                    fontWeight: 700,
                                    color: Colors.white,
                                    textAlign: 'center',
                                  }}>
                                  Request Confirmation
                                </SociollaText>
                              }
                              onPress={() =>
                                changeStatus(detailData, 'need_approval')
                              }
                            />
                          </View>
                        ) : (
                          false
                        )
                      }

                      {/* {
                        // show request confirmation button when status is draft
                        hasAccess &&
                          hasRequestConfirmationAccess &&
                          detailData.status == 'need_approval' ? (
                          <View
                            style={{
                              position: 'absolute',
                              right: 0,
                              left: 0,
                              bottom: -50,
                            }}>
                            <Button
                              rounded

                              buttonStyle={{ width: '100%', backgroundColor: "#25a743", borderColor: "#25a743" }}
                              disabledStyle={{ width: '100%' }}
                              disabled={isDisabledRequestConfirmation()}
                              title={
                                <SociollaText
                                  type="bold"
                                  style={{
                                    fontSize: 12,
                                    lineHeight: 20,
                                    fontWeight: 700,
                                    color: Colors.white,
                                    textAlign: 'center'
                                  }}>
                                  Approval
                                </SociollaText>
                              }
                              onPress={() =>
                                changeStatus(detailData, 'approved')
                              }
                            />
                          </View>
                        ) : (
                          false
                        )
                      } */}
                    </View>
                  )}
                </View>
                <View style={{ paddingVertical: 15 }}>
                  <ItemDetail
                    name="Order Number"
                    value={detailData.reference_code}
                  />
                  <ItemDetail
                    name="Status"
                    centered
                    value={<StatusBadge status={detailData.status} />}
                  />
                  {detailData?.status == 'need_approval' && (
                    <ItemDetail
                      name="Waiting Approval"
                      withoutBorder={true}
                      valueComponent={
                        <View style={{ flexDirection: 'column' }}>
                          {detailData?.status == 'need_approval'
                            ? detailData.waiting_approvals?.length &&
                              detailData.waiting_approvals.map(
                                (appr, index) => (
                                  <User
                                    name={appr.name || ''}
                                    image={appr.image || ''}
                                    key={'list-user-approval-' + index}
                                    index={index}
                                    style={{ paddingBottom: 10 }}
                                  />
                                ),
                              )
                            : false}
                        </View>
                      }
                    />
                  )}
                  {/* <ItemDetail
                    name="R-invoice Status"
                    centered
                    value={<StatusBadge status={detailData.invoice_status} />}
                  /> */}
                </View>
              </View>
              {/* Start Tab Container */}
              <View
                style={[
                  styles.rowContainer,
                  styles.rowBorderBottom,
                  { justifyContent: isWeb ? 'flex-start' : 'space-between' },
                ]}>
                {tabs.map((item, idx) => (
                  <TouchableOpacity
                    activeOpacity={0.6}
                    style={[
                      styles.tabItem,
                      activeTab == item.key ? styles.tabItemActive : {},
                      isWeb
                        ? { width: 160, paddingHorizontal: 20 }
                        : { paddingHorizontal: 70 },
                    ]}
                    key={item.key}
                    onPress={() => setActiveTab(item.key)}>
                    <SociollaText
                      style={[
                        styles.tabText,
                        activeTab == item.key ? styles.tabTextActive : {},
                        isWeb ? { alignSelf: 'center' } : {},
                      ]}>
                      {item.name}
                    </SociollaText>
                  </TouchableOpacity>
                ))}
              </View>
              {/* End Tab Container */}
              <View
                style={[
                  styles.sectionWrapper,
                  {
                    padding: 0,
                    paddingBottom: detailData.status == 'draft' ? 55 : 0,
                  },
                  isWeb ? { overflow: 'auto' } : {},
                  hasFooter ? { marginBottom: 70 } : {},
                ]}>
                {/* Start Header Tab Content */}
                {activeTab == 1 ? (
                  <OrderHeader
                    detailData={detailData}
                    detailCustomer={detailCustomer}
                    {...props}
                  />
                ) : (
                  false
                )}
                {/* End Header Tab Content */}

                {/* Start Order Lines Tab Content */}
                {activeTab == 2 ? (
                  <OrderLines
                    detailData={detailData}
                    products={products}
                    skip={skip}
                    limit={limit}
                    onLoadMoreProducts={({ keyword, skip }) =>
                      getProductReturn(detailData?._id, skip, keyword)
                    }
                    onSearch={({ keyword, skip }) => {
                      getProductReturn(detailData?._id, skip, keyword);
                    }}
                  />
                ) : (
                  false
                )}
                {/* End Order Lines Tab Content */}
              </View>
            </Layout.ScrollViewRefresher>
            {!getSalesOrderDetail.loading ? (
              <>
                {
                  // show confirm button when status is need approval and user role is superadmin or branch head
                  !isWeb &&
                    detailData.status == 'need_approval' &&
                    canApproval() && (
                      <Layout.ButtonSticky
                        show={
                          props?.route?.name == 'ReturnOrderDetailScreen' &&
                          Boolean(detailData?._id)
                        }
                        route={props?.route}
                        buttons={[
                          {
                            title: 'Confirm',
                            onPress: () => changeStatus(detailData, 'approved'),
                          },
                        ]}
                      />
                    )
                }
                {
                  // show request confirmation button when status is draft
                  !isWeb &&
                    hasAccess &&
                    hasRequestConfirmationAccess &&
                    detailData.status == 'draft' && (
                      <Layout.ButtonSticky
                        show={
                          props?.route?.name == 'ReturnOrderDetailScreen' &&
                          Boolean(detailData?._id)
                        }
                        route={props?.route}
                        buttons={[
                          {
                            title: 'Request Confirmation',
                            disabled: isDisabledRequestConfirmation(),
                            onPress: () =>
                              changeStatus(detailData, 'need_approval'),
                          },
                        ]}
                      />
                    )
                }
              </>
            ) : (
              false
            )}
          </>
        ) : (
          <View style={{ width: '100%', padding: 20 }}>
            <SociollaText>No data found.</SociollaText>
          </View>
        )}
      </Layout.Wrapper>
      <Alert />
      {detailData._id ? (
        <>
          {isWeb ? (
            <FloatCommentButton
              onPress={() => setShowComments(true)}
              drawerVisible={showComments}
              entityType="return_order"
              entityId={detailData._id}
            />
          ) : (
            false
          )}
          <CommentDrawer
            visible={showComments}
            onClose={() => setShowComments(false)}
            entityType="return_order"
            entityId={detailData._id}
            entityRef={detailData.reference_code}
          />
        </>
      ) : (
        false
      )}
    </Layout.Container>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: { width: '100%', padding: 15 },
  rowContainer: { flexDirection: 'row', alignItems: 'center' },
  rowBorderBottom: { borderBottomColor: Colors.grey0, borderBottomWidth: 1 },
  tabItem: {
    paddingVertical: 15,
    borderBottomWidth: 3,
    borderBottomColor: 'transparent',
  },
  tabItemActive: {
    borderBottomColor: Colors.blue0,
  },
  tabText: {
    fontSize: 14,
  },
  tabTextActive: {
    color: Colors.blue0,
    fontFamily: 'figtree-medium',
  },
});

export default ReturnOrderDetailScreen;
